import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { env } from '../../env';
import { getMenuIcon } from '../icons/menu';


const LinksUserModal = ({ isOpen, onRequestClose, selectedTrialLinkId, linkType = 'trial_link' }) => {

  const [linkData, setLinkData] = useState({
    id: selectedTrialLinkId,
    users: []
  });

  const handleTrialLinkUsersFetch = async (linkId) => {
    try {
      const data = await env.http
        .get(`${linkType}/users/${linkId}`)
        .then(response => response.data);

        setLinkData({...linkData, users: data.users}
      );
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const buildLinkBody = () => {
    if (!linkData.users)
        return null;

    const body = linkData.users.map((user, index) => {
            return (
              <tr key={user.id}>
                  <td style={{ flex: 1 }}>{index + 1})  {user.name}</td>
                  <td style={{ flex: 1, alignItems: 'center', color: (user.revenue > 0) ? "green" : "black" }}>
                      $ {user.revenue}
                  </td>
                  <td style={{ flex: 1, alignItems: 'center', paddingLeft: '20px' }}>{user.created_at}</td>
              </tr>
              );
          }
      );
    return (body)
  }

  useEffect(() => {
    if (selectedTrialLinkId && isOpen) {
      handleTrialLinkUsersFetch(selectedTrialLinkId);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
          width: 'fit-content',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)'

        }
      }}>
        <div className='links-body'>
            <div className='links_popup_header'>
                <h2>Fans</h2>
                <button onClick={onRequestClose}>
                    {getMenuIcon('close')}
                </button>
            </div>
            <div className='links_popup_content'>
                <table className='table' style={{ tableLayout: 'fixed' }}>
                       <thead className='links-thead' >
                            <tr>
                                <th style={{ flex: 1 }}>No   Name</th>
                                <th style={{ flex: 1 }}>Spend since claim</th>
                                <th style={{ flex: 1 }}>Claimed</th>
                            </tr>
                        </thead>
                        <tbody className='links-tbody'>
                            {buildLinkBody()}
                        </tbody>
                </table>
            </div>
        </div>

    </Modal>
  );
};

export default LinksUserModal;
